(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cca-master-purchase-reassurance"] && !Shopify.designMode) return;
  try {
    if (!window.ccaPurchaseInboxTriggerReady) {
    window.ccaPurchaseInboxTriggerReady = true;

    const findPurchaseInbox = () => {
      const inbox = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
      const directLauncher = inbox?.shadowRoot?.querySelector('button');
      const runtime = inbox?.shadowRoot?.querySelector('shopify-agent-runtime');
      const runtimeRoot = runtime?.shadowRoot;
      const launcher = directLauncher || runtimeRoot?.querySelector('button[part="activator"]');
      const panel = runtimeRoot?.querySelector('[role="dialog"]');
      const isOpen = inbox
        && (
          inbox.getAttribute('is-open') === 'true'
          || inbox.hasAttribute('open')
          || launcher?.getAttribute('aria-expanded') === 'true'
          || (panel && !panel.hasAttribute('inert'))
        );

      return { launcher, isOpen };
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-purchase-inbox-trigger]');
      if (!button || button.dataset.inboxOpening === 'true') return;

      button.dataset.inboxOpening = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      const statusId = button.getAttribute('aria-describedby');
      const status = statusId ? document.getElementById(statusId) : null;
      if (status) status.textContent = button.dataset.loading;

      let lastLaunch = 0;
      let openSince = 0;
      let observer;
      let retry;
      let timeout;

      const finish = (opened) => {
        observer?.disconnect();
        if (retry) window.clearInterval(retry);
        if (timeout) window.clearTimeout(timeout);

        delete button.dataset.inboxOpening;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = opened ? button.dataset.opened : button.dataset.unavailable;
      };

      const attempt = () => {
        const { launcher, isOpen } = findPurchaseInbox();
        if (isOpen) {
          if (!openSince) openSince = Date.now();
          if (Date.now() - openSince >= 350) finish(true);
          return;
        }

        openSince = 0;
        if (launcher && Date.now() - lastLaunch >= 750) {
          lastLaunch = Date.now();
          launcher.click();
        }
      };

      attempt();
      observer = new MutationObserver(attempt);
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
      retry = window.setInterval(attempt, 100);
      timeout = window.setTimeout(() => finish(false), 8000);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["how-to-measure-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('how-to-measure-guide')) {
    customElements.define('how-to-measure-guide', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.scroller = this.querySelector('.htm-guide__scroller');
        this.closeButton = this.querySelector('.htm-guide__close');
        this.imageShell = this.querySelector('[data-htm-image-shell]');
        this.zoomTrigger = this.querySelector('.htm-guide__zoom-trigger');
        this.zoomDialog = this.querySelector('.htm-guide__zoom-dialog');
        this.zoomCloseButton = this.querySelector('.htm-guide__zoom-close');
        this.zoomScroller = this.querySelector('.htm-guide__zoom-scroller');
        this.zoomImage = this.querySelector('.htm-guide__zoom-image');
        this.zoomMedia = window.matchMedia('(max-width: 899px)');
        this.launcherTemplate = this.querySelector('.htm-guide__launcher-template');
        this.disclosure = this.querySelector('.htm-guide__disclosure');
        this.disclosureContent = this.disclosure && this.disclosure.querySelector('.htm-guide__disclosure-content');
        this.videoFrame = this.querySelector('.htm-guide__video-frame');
        this.videoTemplate = this.videoFrame ? this.videoFrame.innerHTML : '';
        this.chatButton = this.querySelector('.htm-guide__chat-button');
        this.chatStatus = this.querySelector('[data-htm-chat-status]');
        this.lastLauncher = null;
        this.scrollbarWidth = 0;
        this.bodyPaddingRight = '';
        this.backdropPointerId = null;
        this.backdropTouchId = null;
        this.zoomBackdropPointerId = null;
        this.zoomBackdropTouchId = null;
        this.tapGuardCleanup = null;
        this.restoreKeyboardFocusRing = false;
        this.restoreZoomFocus = false;
        this.disclosureAutoScrollFrame = null;
        this.openInboxAfterClose = false;
        this.chatOpening = false;
        this.chatLaunchTriggered = false;
        this.chatObserver = null;
        this.chatRetry = null;
        this.chatTimeout = null;
        this.videoIframe = null;
        this.videoReady = false;
        this.videoPendingPlay = false;
        this.videoKeyboardStart = false;
        this.videoListenRetry = null;
        this.videoReadyTimeout = null;
        this.boundVideoMessage = (event) => this.handleVideoMessage(event);
        this.boundZoomMediaChange = (event) => {
          if (!event.matches) this.closeImageZoom(false);
        };

        if (this.dataset.autoLauncher !== 'false') this.addLauncher();
        window.addEventListener('message', this.boundVideoMessage);
        this.zoomMedia.addEventListener('change', this.boundZoomMediaChange);
        this.closeButton.addEventListener('click', (event) => {
          this.restoreKeyboardFocusRing = event.detail === 0;
          this.close();
        });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.restoreKeyboardFocusRing = true;
          this.close();
        });
        this.dialog.addEventListener('close', () => this.afterClose());
        this.dialog.addEventListener('keydown', (event) => {
          this.dialog
            .querySelectorAll('.htm-guide__suppress-pointer-focus')
            .forEach((control) => control.classList.remove('htm-guide__suppress-pointer-focus'));
          if (event.key === 'Escape') {
            event.preventDefault();
            this.restoreKeyboardFocusRing = true;
            this.close();
            return;
          }
          if (event.key === 'Tab') this.trapFocus(event);
        });

        if (this.zoomTrigger && this.imageShell && this.zoomDialog && this.zoomCloseButton) {
          this.zoomTrigger.addEventListener('pointerdown', (event) => this.suppressPointerFocus(event));
          this.zoomTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.restoreZoomFocus = event.detail === 0;
            this.openImageZoom();
          });
          this.imageShell.addEventListener('click', (event) => {
            if (!this.zoomMedia.matches || event.target.closest('.htm-guide__zoom-trigger')) return;
            this.restoreZoomFocus = false;
            this.openImageZoom();
          });
          this.zoomCloseButton.addEventListener('click', (event) => {
            this.restoreZoomFocus = event.detail === 0;
            this.closeImageZoom(true);
          });
          this.zoomImage?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.restoreZoomFocus = false;
            this.closeImageZoom(true);
          });
          this.zoomScroller.addEventListener('click', (event) => {
            if (event.target !== this.zoomScroller) return;
            event.preventDefault();
            event.stopPropagation();
            this.restoreZoomFocus = false;
            this.closeImageZoom(true);
          });
          this.zoomDialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.restoreZoomFocus = true;
            this.closeImageZoom(true);
          });
          this.zoomDialog.addEventListener('close', () => this.afterImageZoomClose());
          this.zoomDialog.addEventListener('keydown', (event) => {
            this.zoomDialog
              .querySelectorAll('.htm-guide__suppress-pointer-focus')
              .forEach((control) => control.classList.remove('htm-guide__suppress-pointer-focus'));
            if (event.key === 'Escape') {
              event.preventDefault();
              event.stopPropagation();
              this.restoreZoomFocus = true;
              this.closeImageZoom(true);
              return;
            }
            if (event.key === 'Tab') this.trapFocus(event, this.zoomDialog);
          });

          if (window.PointerEvent) {
            this.zoomDialog.addEventListener('pointerdown', (event) => {
              this.suppressPointerFocus(event);
              this.startZoomBackdropPointer(event);
            });
            this.zoomDialog.addEventListener('pointerup', (event) => this.endZoomBackdropPointer(event));
            this.zoomDialog.addEventListener('pointercancel', () => {
              this.zoomBackdropPointerId = null;
            });
          } else {
            this.zoomDialog.addEventListener('touchstart', (event) => this.startZoomBackdropTouch(event), { passive: false });
            this.zoomDialog.addEventListener('touchend', (event) => this.endZoomBackdropTouch(event), { passive: false });
            this.zoomDialog.addEventListener('touchcancel', () => {
              this.zoomBackdropTouchId = null;
            });
          }
        }

        if (window.PointerEvent) {
          this.dialog.addEventListener('pointerdown', (event) => {
            this.suppressPointerFocus(event);
            this.startBackdropPointer(event);
          });
          this.dialog.addEventListener('pointerup', (event) => this.endBackdropPointer(event));
          this.dialog.addEventListener('pointercancel', () => {
            this.backdropPointerId = null;
          });
        } else {
          this.dialog.addEventListener('touchstart', (event) => this.startBackdropTouch(event), { passive: false });
          this.dialog.addEventListener('touchend', (event) => this.endBackdropTouch(event), { passive: false });
          this.dialog.addEventListener('touchcancel', () => {
            this.backdropTouchId = null;
          });
        }

        if (this.disclosure) {
          const button = this.disclosure.querySelector('.htm-guide__disclosure-button');
          if (button) button.addEventListener('click', () => this.toggleDisclosure());
        }

        if (this.chatButton) {
          this.chatButton.addEventListener('click', (event) => this.handleChatRequest(event));
        }

        this.bindVideoButton();

        if (this.dataset.autoLauncher !== 'false') {
          this.observer = new MutationObserver(() => this.addLauncher());
          const productInfo = this.closest('product-info');
          if (productInfo) this.observer.observe(productInfo, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.tapGuardCleanup) this.tapGuardCleanup();
        if (this.disclosureAutoScrollFrame) window.cancelAnimationFrame(this.disclosureAutoScrollFrame);
        window.removeEventListener('message', this.boundVideoMessage);
        this.zoomMedia?.removeEventListener('change', this.boundZoomMediaChange);
        this.finishChatRequest(false, false);
        this.closeImageZoom(false);
        this.clearVideoTimers();
        this.lastLauncher = null;
        if (this.dialog && this.dialog.open) this.dialog.close();
        else this.afterClose(false);
      }

      addLauncher() {
        if (document.querySelector('.htm-guide__launcher[data-guide-section="' + this.dataset.sectionId + '"]')) return;
        const productInfo = this.closest('product-info');
        if (!productInfo || !this.launcherTemplate) return;
        const legends = Array.from(productInfo.querySelectorAll('variant-selects fieldset legend, variant-radios fieldset legend'));
        const sizeLegend = legends.find((legend) => /size/i.test(legend.textContent));
        if (!sizeLegend) return;
        sizeLegend.classList.add('htm-guide__label-row');
        const launcher = this.launcherTemplate.content.firstElementChild.cloneNode(true);
        launcher.dataset.guideSection = this.dataset.sectionId;
        launcher.setAttribute('aria-haspopup', 'dialog');
        launcher.setAttribute('aria-controls', this.dialog.id);
        const launcherText = launcher.querySelector('.htm-guide__launcher-text');
        if (launcherText) launcherText.textContent = this.dataset.launcherLabel;
        launcher.addEventListener('pointerdown', (event) => this.suppressPointerFocus(event));
        launcher.addEventListener('keydown', () => {
          launcher.classList.remove('htm-guide__launcher--suppress-focus', 'htm-guide__suppress-pointer-focus');
        });
        launcher.addEventListener('click', (event) => {
          this.restoreKeyboardFocusRing = event.detail === 0;
          this.open(launcher);
        });
        sizeLegend.appendChild(launcher);
      }

      suppressPointerFocus(event) {
        const control = event.target.closest('button');
        if (!control) return;
        control.classList.add('htm-guide__suppress-pointer-focus');
        control.addEventListener(
          'blur',
          () => control.classList.remove('htm-guide__suppress-pointer-focus'),
          { once: true }
        );
      }

      open(launcher) {
        if (this.dialog.open) return;
        if (this.tapGuardCleanup) this.tapGuardCleanup();
        this.lastLauncher = launcher;
        this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        this.bodyPaddingRight = document.body.style.paddingRight;
        document.documentElement.classList.add('htm-guide-open');
        document.body.classList.add('htm-guide-open');
        if (this.scrollbarWidth > 0) {
          const existingPadding = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
          document.body.style.paddingRight = existingPadding + this.scrollbarWidth + 'px';
        }
        this.prepareVideo();
        this.dialog.showModal();
        this.scroller.scrollTop = 0;
        this.dialog.focus({ preventScroll: true });
      }

      openFrom(launcher, restoreKeyboardFocusRing = false) {
        this.restoreKeyboardFocusRing = restoreKeyboardFocusRing;
        this.open(launcher);
      }

      close() {
        if (this.dialog.open) {
          this.dialog.close();
          return;
        }
        this.afterClose();
      }

      afterClose(restoreFocus = true) {
        const shouldOpenInbox = this.openInboxAfterClose;
        this.openInboxAfterClose = false;
        this.unlockPage();
        this.backdropPointerId = null;
        this.backdropTouchId = null;
        this.closeImageZoom(false);
        this.scroller.scrollTop = 0;
        this.resetVideo();
        this.toggleDisclosure(false);
        if (shouldOpenInbox) {
          this.restoreKeyboardFocusRing = false;
          window.setTimeout(() => this.requestInbox(), 0);
          return;
        }
        if (restoreFocus && this.lastLauncher && document.contains(this.lastLauncher)) {
          if (!this.restoreKeyboardFocusRing) {
            this.lastLauncher.classList.add('htm-guide__launcher--suppress-focus');
            this.lastLauncher.addEventListener('blur', () => {
              this.lastLauncher?.classList.remove('htm-guide__launcher--suppress-focus');
            }, { once: true });
          }
          this.lastLauncher.focus({ preventScroll: true });
        }
        this.restoreKeyboardFocusRing = false;
      }

      unlockPage() {
        document.documentElement.classList.remove('htm-guide-open');
        document.body.classList.remove('htm-guide-open');
        document.body.style.paddingRight = this.bodyPaddingRight;
      }

      isBackdropCoordinates(target, clientX, clientY, dialog = this.dialog) {
        if (target !== dialog) return false;
        const bounds = dialog.getBoundingClientRect();
        return clientX < bounds.left
          || clientX > bounds.right
          || clientY < bounds.top
          || clientY > bounds.bottom;
      }

      isBackdropPoint(event) {
        return this.isBackdropCoordinates(event.target, event.clientX, event.clientY);
      }

      startBackdropPointer(event) {
        if (!this.isBackdropPoint(event)) {
          this.backdropPointerId = null;
          return;
        }
        this.backdropPointerId = event.pointerId;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }

      endBackdropPointer(event) {
        if (event.pointerId !== this.backdropPointerId) return;
        const shouldClose = this.isBackdropPoint(event);
        this.backdropPointerId = null;
        if (event.cancelable) event.preventDefault();
        event.stopImmediatePropagation();
        if (!shouldClose) return;
        this.restoreKeyboardFocusRing = false;
        this.armTapThroughGuard();
        this.close();
      }

      startBackdropTouch(event) {
        const touch = event.changedTouches[0];
        if (!touch || !this.isBackdropCoordinates(event.target, touch.clientX, touch.clientY)) {
          this.backdropTouchId = null;
          return;
        }
        this.backdropTouchId = touch.identifier;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }

      endBackdropTouch(event) {
        const touch = Array.from(event.changedTouches).find((item) => item.identifier === this.backdropTouchId);
        if (!touch) return;
        const shouldClose = this.isBackdropCoordinates(event.target, touch.clientX, touch.clientY);
        this.backdropTouchId = null;
        if (event.cancelable) event.preventDefault();
        event.stopImmediatePropagation();
        if (!shouldClose) return;
        this.restoreKeyboardFocusRing = false;
        this.armTapThroughGuard();
        this.close();
      }

      openImageZoom() {
        if (!this.zoomMedia.matches || !this.dialog.open || this.zoomDialog.open) return;
        this.zoomDialog.showModal();
        window.requestAnimationFrame(() => {
          if (!this.restoreZoomFocus) {
            this.zoomCloseButton.classList.add('htm-guide__suppress-pointer-focus');
            this.zoomCloseButton.addEventListener(
              'blur',
              () => this.zoomCloseButton.classList.remove('htm-guide__suppress-pointer-focus'),
              { once: true }
            );
          }
          this.zoomCloseButton.focus({ preventScroll: true });
        });
      }

      closeImageZoom(restoreFocus = true) {
        if (!this.zoomDialog?.open) return;
        this.restoreZoomFocus = restoreFocus && this.restoreZoomFocus;
        this.zoomDialog.close();
      }

      afterImageZoomClose() {
        this.zoomBackdropPointerId = null;
        this.zoomBackdropTouchId = null;
        if (this.restoreZoomFocus && this.dialog.open && this.zoomTrigger) {
          this.zoomTrigger.focus({ preventScroll: true });
        }
        this.restoreZoomFocus = false;
      }

      startZoomBackdropPointer(event) {
        if (!this.isBackdropCoordinates(event.target, event.clientX, event.clientY, this.zoomDialog)) {
          this.zoomBackdropPointerId = null;
          return;
        }
        this.zoomBackdropPointerId = event.pointerId;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }

      endZoomBackdropPointer(event) {
        if (event.pointerId !== this.zoomBackdropPointerId) return;
        const shouldClose = this.isBackdropCoordinates(event.target, event.clientX, event.clientY, this.zoomDialog);
        this.zoomBackdropPointerId = null;
        if (event.cancelable) event.preventDefault();
        event.stopImmediatePropagation();
        if (!shouldClose) return;
        this.restoreZoomFocus = false;
        this.armTapThroughGuard();
        this.closeImageZoom(true);
      }

      startZoomBackdropTouch(event) {
        const touch = event.changedTouches[0];
        if (!touch || !this.isBackdropCoordinates(event.target, touch.clientX, touch.clientY, this.zoomDialog)) {
          this.zoomBackdropTouchId = null;
          return;
        }
        this.zoomBackdropTouchId = touch.identifier;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }

      endZoomBackdropTouch(event) {
        const touch = Array.from(event.changedTouches).find((item) => item.identifier === this.zoomBackdropTouchId);
        if (!touch) return;
        const shouldClose = this.isBackdropCoordinates(event.target, touch.clientX, touch.clientY, this.zoomDialog);
        this.zoomBackdropTouchId = null;
        if (event.cancelable) event.preventDefault();
        event.stopImmediatePropagation();
        if (!shouldClose) return;
        this.restoreZoomFocus = false;
        this.armTapThroughGuard();
        this.closeImageZoom(true);
      }

      armTapThroughGuard() {
        if (this.tapGuardCleanup) this.tapGuardCleanup();
        let timer;
        const releaseOnNewGesture = () => cleanup();
        const guardClick = (event) => {
          if (event.detail !== 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          cleanup();
        };
        const cleanup = () => {
          document.removeEventListener('click', guardClick, true);
          document.removeEventListener('pointerdown', releaseOnNewGesture, true);
          document.removeEventListener('touchstart', releaseOnNewGesture, true);
          window.clearTimeout(timer);
          if (this.tapGuardCleanup === cleanup) this.tapGuardCleanup = null;
        };
        document.addEventListener('click', guardClick, true);
        document.addEventListener('pointerdown', releaseOnNewGesture, true);
        document.addEventListener('touchstart', releaseOnNewGesture, { capture: true, passive: true });
        timer = window.setTimeout(cleanup, 600);
        this.tapGuardCleanup = cleanup;
      }

      trapFocus(event, dialog = this.dialog) {
        const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], iframe, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => element.getClientRects().length > 0);
        if (focusable.length === 0) {
          event.preventDefault();
          dialog.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      toggleDisclosure(force) {
        if (!this.disclosure || !this.disclosureContent) return;
        const button = this.disclosure.querySelector('.htm-guide__disclosure-button');
        const content = this.disclosureContent;
        if (!button || !content) return;
        const expanded = typeof force === 'boolean'
          ? force
          : button.getAttribute('aria-expanded') !== 'true';
        if (this.disclosureAutoScrollFrame) {
          window.cancelAnimationFrame(this.disclosureAutoScrollFrame);
          this.disclosureAutoScrollFrame = null;
        }
        if (!expanded) {
          this.scroller.scrollTo({ top: this.scroller.scrollTop, behavior: 'auto' });
        }
        button.setAttribute('aria-expanded', String(expanded));
        content.hidden = !expanded;
        this.dialog.classList.toggle('htm-guide__dialog--disclosure-open', expanded);
        const icon = button.querySelector('.htm-guide__disclosure-icon');
        if (icon) icon.textContent = expanded ? '−' : '+';
        if (expanded && this.zoomMedia.matches) this.revealDisclosureIntoView();
      }

      revealDisclosureIntoView() {
        this.disclosureAutoScrollFrame = window.requestAnimationFrame(() => {
          this.disclosureAutoScrollFrame = null;
          if (!this.dialog.open || !this.zoomMedia.matches || !this.disclosure || !this.scroller) return;

          const viewport = this.scroller.getBoundingClientRect();
          const disclosure = this.disclosure.getBoundingClientRect();
          const inset = 16;
          const visibleTop = viewport.top + inset;
          const visibleBottom = viewport.bottom - inset;
          let delta = 0;

          if (disclosure.bottom > visibleBottom) {
            delta = disclosure.bottom - visibleBottom;
          } else if (disclosure.top < visibleTop) {
            delta = disclosure.top - visibleTop;
          }

          if (Math.abs(delta) < 1) return;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scroller.scrollBy({
            top: delta,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        });
      }

      handleChatRequest(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.chatOpening || this.openInboxAfterClose) return;

        this.chatOpening = true;
        this.openInboxAfterClose = true;
        this.chatButton.disabled = true;
        this.chatButton.setAttribute('aria-busy', 'true');
        if (this.chatStatus) this.chatStatus.textContent = this.dataset.supportLoading;
        this.restoreKeyboardFocusRing = false;
        this.close();
      }

      requestInbox() {
        const openInbox = () => {
          const inbox = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
          const directLauncher = inbox
            && inbox.shadowRoot
            && inbox.shadowRoot.querySelector('button');
          const runtime = inbox
            && inbox.shadowRoot
            && inbox.shadowRoot.querySelector('shopify-agent-runtime');
          const runtimeRoot = runtime && runtime.shadowRoot;
          const launcher = directLauncher
            || (runtimeRoot && runtimeRoot.querySelector('button[part="activator"]'));
          const panel = runtimeRoot && runtimeRoot.querySelector('[role="dialog"]');
          if (
            inbox
            && (
              inbox.getAttribute('is-open') === 'true'
              || inbox.hasAttribute('open')
              || launcher?.getAttribute('aria-expanded') === 'true'
              || (panel && !panel.hasAttribute('inert'))
            )
          ) {
            this.finishChatRequest(true);
            return true;
          }

          const currentInboxReady = inbox?.tagName !== 'SHOPIFY-CHAT'
            || Boolean(directLauncher)
            || inbox.hasAttribute('shell-ready')
            || runtime?.hasAttribute('shell-ready');
          if (!currentInboxReady) return false;
          if (!launcher || this.chatLaunchTriggered) return false;

          this.chatLaunchTriggered = true;
          launcher.click();
          return false;
        };

        if (openInbox()) return;

        this.chatObserver = new MutationObserver(() => openInbox());
        this.chatObserver.observe(document.documentElement, { childList: true, subtree: true });
        this.chatRetry = window.setInterval(() => openInbox(), 100);
        this.chatTimeout = window.setTimeout(() => this.finishChatRequest(false), 8000);
      }

      finishChatRequest(opened, updateStatus = true) {
        if (this.chatObserver) this.chatObserver.disconnect();
        if (this.chatRetry) window.clearInterval(this.chatRetry);
        if (this.chatTimeout) window.clearTimeout(this.chatTimeout);
        this.chatObserver = null;
        this.chatRetry = null;
        this.chatTimeout = null;
        this.chatOpening = false;
        this.chatLaunchTriggered = false;
        if (this.chatButton) {
          this.chatButton.disabled = false;
          this.chatButton.removeAttribute('aria-busy');
        }
        if (updateStatus && this.chatStatus) {
          this.chatStatus.textContent = opened
            ? this.dataset.supportOpened
            : this.dataset.supportUnavailable;
        }
      }

      bindVideoButton() {
        const button = this.videoFrame && this.videoFrame.querySelector('.htm-guide__video-button');
        if (!button || button.dataset.guideBound) return;
        button.dataset.guideBound = 'true';
        button.addEventListener('click', (event) => this.playVideo(button, event));
      }

      prepareVideo() {
        if (!this.videoFrame || this.videoIframe) return;
        const iframe = document.createElement('iframe');
        const params = new URLSearchParams({
          autoplay: '0',
          start: this.dataset.videoStart,
          rel: '0',
          playsinline: '1',
          enablejsapi: '1',
          origin: window.location.origin
        });
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?' + params.toString();
        iframe.id = 'HowToMeasureVideo-' + this.dataset.sectionId;
        iframe.title = this.videoFrame.querySelector('.htm-guide__video-button')?.getAttribute('aria-label') || 'Play video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.tabIndex = -1;
        iframe.addEventListener('load', () => this.startVideoListening());
        this.videoIframe = iframe;
        this.videoFrame.prepend(iframe);
        this.armVideoReadyTimeout();
      }

      armVideoReadyTimeout() {
        if (this.videoReadyTimeout) window.clearTimeout(this.videoReadyTimeout);
        this.videoReadyTimeout = window.setTimeout(() => {
          if (this.videoReady) return;
          if (this.videoListenRetry) window.clearInterval(this.videoListenRetry);
          this.videoListenRetry = null;
          this.videoReadyTimeout = null;
          this.videoPendingPlay = false;
          this.videoFrame.classList.remove('htm-guide__video-frame--waiting');
          const button = this.videoFrame.querySelector('.htm-guide__video-button');
          button?.removeAttribute('aria-busy');
        }, 10000);
      }

      startVideoListening() {
        if (!this.videoIframe) return;
        const listen = () => {
          this.videoIframe?.contentWindow?.postMessage(
            JSON.stringify({ event: 'listening', id: this.videoIframe.id }),
            'https://www.youtube-nocookie.com'
          );
        };
        listen();
        if (this.videoListenRetry) window.clearInterval(this.videoListenRetry);
        this.videoListenRetry = window.setInterval(listen, 250);
      }

      handleVideoMessage(event) {
        if (
          !this.videoIframe
          || event.source !== this.videoIframe.contentWindow
          || event.origin !== 'https://www.youtube-nocookie.com'
        ) return;
        let message = event.data;
        if (typeof message === 'string') {
          try {
            message = JSON.parse(message);
          } catch (error) {
            return;
          }
        }
        if (message?.event !== 'onReady') return;
        this.videoReady = true;
        if (this.videoListenRetry) window.clearInterval(this.videoListenRetry);
        if (this.videoReadyTimeout) window.clearTimeout(this.videoReadyTimeout);
        this.videoListenRetry = null;
        this.videoReadyTimeout = null;
        if (this.videoPendingPlay) this.startVideoPlayback();
      }

      playVideo(button, event) {
        if (!this.videoFrame || this.videoFrame.classList.contains('htm-guide__video-frame--playing')) return;
        this.prepareVideo();
        if (!this.videoReady && !this.videoListenRetry) {
          this.startVideoListening();
          this.armVideoReadyTimeout();
        }
        if (this.videoPendingPlay) return;
        this.videoPendingPlay = true;
        this.videoKeyboardStart = event.detail === 0;
        button.setAttribute('aria-busy', 'true');
        this.videoFrame.classList.add('htm-guide__video-frame--waiting');
        if (this.videoReady) this.startVideoPlayback();
      }

      startVideoPlayback() {
        if (!this.videoIframe || !this.videoReady) return;
        this.videoIframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo', args: [], id: this.videoIframe.id }),
          'https://www.youtube-nocookie.com'
        );
        this.videoPendingPlay = false;
        this.videoFrame.classList.remove('htm-guide__video-frame--waiting');
        this.videoFrame.classList.add('htm-guide__video-frame--playing');
        const button = this.videoFrame.querySelector('.htm-guide__video-button');
        button?.removeAttribute('aria-busy');
        this.videoIframe.removeAttribute('tabindex');
        if (this.videoKeyboardStart) this.videoIframe.focus({ preventScroll: true });
        this.videoKeyboardStart = false;
      }

      clearVideoTimers() {
        if (this.videoListenRetry) window.clearInterval(this.videoListenRetry);
        if (this.videoReadyTimeout) window.clearTimeout(this.videoReadyTimeout);
        this.videoListenRetry = null;
        this.videoReadyTimeout = null;
      }

      resetVideo() {
        if (!this.videoFrame || !this.videoTemplate) return;
        this.clearVideoTimers();
        this.videoFrame.innerHTML = this.videoTemplate;
        this.videoFrame.classList.remove('htm-guide__video-frame--waiting', 'htm-guide__video-frame--playing');
        this.videoIframe = null;
        this.videoReady = false;
        this.videoPendingPlay = false;
        this.videoKeyboardStart = false;
        this.bindVideoButton();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
